module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "list"
  }, [_c('div', {
    staticClass: "breadcrumb"
  }, [_c('Breadcrumb', [_c('Breadcrumb-item', [_vm._v("学生管理")]), _vm._v(" "), _c('Breadcrumb-item', [_vm._v("学员风险")])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "search",
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.search.apply(null, arguments)
      }
    }
  }, [_c('Form', {
    attrs: {
      "label-width": 100,
      "show-message": false,
      "label-position": "right"
    }
  }, [_c('Row', {
    attrs: {
      "gutter": 32
    }
  }, [_c('Col', {
    attrs: {
      "span": 6
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "等级"
    }
  }, [_c('Select', {
    attrs: {
      "clearable": "",
      "placeholder": "全部"
    },
    model: {
      value: (_vm.queryParam.level),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "level", $$v)
      },
      expression: "queryParam.level"
    }
  }, [_c('Option', {
    attrs: {
      "value": 0
    }
  }, [_vm._v("低")]), _vm._v(" "), _c('Option', {
    attrs: {
      "value": 1
    }
  }, [_vm._v("中")]), _vm._v(" "), _c('Option', {
    attrs: {
      "value": 2
    }
  }, [_vm._v("高")])], 1)], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": 6
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "学导"
    }
  }, [_c('admin-user-select', {
    attrs: {
      "status": 1,
      "adminGroupCode": "userStudyAdviser"
    },
    model: {
      value: (_vm.queryParam.studyAdviserId),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "studyAdviserId", $$v)
      },
      expression: "queryParam.studyAdviserId"
    }
  })], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": 6
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "天数"
    }
  }, [_c('InputNumber', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "min": 1,
      "max": 90
    },
    model: {
      value: (_vm.queryParam.days),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "days", $$v)
      },
      expression: "queryParam.days"
    }
  })], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": 6
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "仅未跟进"
    }
  }, [_c('i-switch', {
    model: {
      value: (_vm.queryParam.unfollowedOnly),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "unfollowedOnly", $$v)
      },
      expression: "queryParam.unfollowedOnly"
    }
  })], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": 6
    }
  }, [_c('Button', {
    attrs: {
      "type": "primary",
      "loading": _vm.searchLoading,
      "disable": _vm.searchLoading,
      "icon": "search"
    },
    on: {
      "click": _vm.search
    }
  }, [_vm._v("搜索")])], 1)], 1)], 1)], 1), _vm._v(" "), (_vm.aiAllowed) ? _c('List', {
    ref: "dataList",
    attrs: {
      "tableColumns": _vm.title,
      "reload": _vm.reload,
      "listUrl": "/studentRisk/list",
      "params": _vm.queryParam,
      "onLoading": _vm.onLoading
    }
  }) : _vm._e(), _vm._v(" "), _c('AiDrawer', {
    attrs: {
      "visible": _vm.aiVisible,
      "uid": _vm.aiUid,
      "snapshot-id": _vm.aiSnapshotId,
      "page-route": "/user/studentRiskList",
      "default-task-type": "RISK_EXPLAIN"
    },
    on: {
      "update:visible": function($event) {
        _vm.aiVisible = $event
      },
      "on-executed": _vm.onAiExecuted,
      "on-close": _vm.onAiClose
    }
  }), _vm._v(" "), _c('Modal', {
    attrs: {
      "title": "写跟进",
      "mask-closable": false
    },
    model: {
      value: (_vm.showFollowupModal),
      callback: function($$v) {
        _vm.showFollowupModal = $$v
      },
      expression: "showFollowupModal"
    }
  }, [_c('Form', {
    attrs: {
      "label-width": 90
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "动作",
      "required": ""
    }
  }, [_c('Select', {
    attrs: {
      "placeholder": "请选择"
    },
    model: {
      value: (_vm.followupForm.action),
      callback: function($$v) {
        _vm.$set(_vm.followupForm, "action", $$v)
      },
      expression: "followupForm.action"
    }
  }, [_c('Option', {
    attrs: {
      "value": "CALL"
    }
  }, [_vm._v("CALL 电话")]), _vm._v(" "), _c('Option', {
    attrs: {
      "value": "REMARK"
    }
  }, [_vm._v("REMARK 备注")]), _vm._v(" "), _c('Option', {
    attrs: {
      "value": "TRANSFER"
    }
  }, [_vm._v("TRANSFER 转交")]), _vm._v(" "), _c('Option', {
    attrs: {
      "value": "IGNORE"
    }
  }, [_vm._v("IGNORE 忽略")])], 1)], 1), _vm._v(" "), _c('Form-item', {
    attrs: {
      "label": "结果"
    }
  }, [_c('Select', {
    attrs: {
      "clearable": "",
      "placeholder": "可空"
    },
    model: {
      value: (_vm.followupForm.result),
      callback: function($$v) {
        _vm.$set(_vm.followupForm, "result", $$v)
      },
      expression: "followupForm.result"
    }
  }, [_c('Option', {
    attrs: {
      "value": "MISREPORT"
    }
  }, [_vm._v("MISREPORT")]), _vm._v(" "), _c('Option', {
    attrs: {
      "value": "SCHEDULE"
    }
  }, [_vm._v("SCHEDULE")]), _vm._v(" "), _c('Option', {
    attrs: {
      "value": "LEARNING"
    }
  }, [_vm._v("LEARNING")]), _vm._v(" "), _c('Option', {
    attrs: {
      "value": "SERVICE"
    }
  }, [_vm._v("SERVICE")]), _vm._v(" "), _c('Option', {
    attrs: {
      "value": "PRICE"
    }
  }, [_vm._v("PRICE")]), _vm._v(" "), _c('Option', {
    attrs: {
      "value": "PAUSE"
    }
  }, [_vm._v("PAUSE")]), _vm._v(" "), _c('Option', {
    attrs: {
      "value": "RECOVERED"
    }
  }, [_vm._v("RECOVERED")]), _vm._v(" "), _c('Option', {
    attrs: {
      "value": "LOST"
    }
  }, [_vm._v("LOST")])], 1)], 1), _vm._v(" "), _c('Form-item', {
    attrs: {
      "label": "说明"
    }
  }, [_c('Input', {
    attrs: {
      "type": "textarea",
      "rows": 3,
      "placeholder": "跟进说明"
    },
    model: {
      value: (_vm.followupForm.comment),
      callback: function($$v) {
        _vm.$set(_vm.followupForm, "comment", $$v)
      },
      expression: "followupForm.comment"
    }
  })], 1), _vm._v(" "), _c('Form-item', {
    attrs: {
      "label": "写跟踪"
    }
  }, [_c('Checkbox', {
    model: {
      value: (_vm.followupForm.writeTrack),
      callback: function($$v) {
        _vm.$set(_vm.followupForm, "writeTrack", $$v)
      },
      expression: "followupForm.writeTrack"
    }
  }, [_vm._v("同时写 user_track_record（trackType=61，不推送）")])], 1)], 1), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('Button', {
    attrs: {
      "type": "text",
      "size": "large"
    },
    on: {
      "click": function($event) {
        _vm.showFollowupModal = false
      }
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('Button', {
    attrs: {
      "type": "primary",
      "size": "large",
      "loading": _vm.followupLoading
    },
    on: {
      "click": _vm.submitFollowup
    }
  }, [_vm._v("确定")])], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4128e332","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/user/StudentRiskList.vue
// module id = 1779
// module chunks = 8